import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./CardStars.module.scss";
import {CardStar} from "../card-star/CardStar";
import {isDefined, isUndefined} from "../../../util/is-type";

export type CardStarsValueType = 0 | 1 | 2 | 3;

export interface ICardStarsProps {
  value?: CardStarsValueType;
  min?: 0 | 1 | 2;
}

export const CardStars: VoidFunctionComponent<ICardStarsProps> = ({value, min}) => {

  if (
    // do we have a value for number of stars
    isUndefined(value)
    // do we have a min and value is less than min
    || (
      isDefined(min)
      && value < min
    )
  ) {
    // shouldn't return stars due to no value
    return null;
  }

  return (
    <div className={s.stars}>
      <CardStar isAwarded={value >= 1} />
      <CardStar isAwarded={value >= 2} />
      <CardStar isAwarded={value >= 3} />
    </div>
  );
}

